'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _priorityNav = require('priority-nav');

var _priorityNav2 = _interopRequireDefault(_priorityNav);

var _globalEventBus = require('../library/global-event-bus');

var _stringUtility = require('../library/string-utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'tabmenu',

    template: require('./tabmenu.component.html'),

    props: {
        modifier: String,
        tabs: {
            type: Object,
            default: function _default() {
                var tabs = {};
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(this.$slots)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var identifier = _step.value;

                        tabs[identifier] = { title: identifier };
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return tabs;
            }
        }
    },

    data: function data() {
        return {
            active: null,
            ignore: false,
            randomClass: 'c-ff-tabs-wrapper--' + Math.random().toString(26).substr(2, 7)
        };
    },


    /**
     * Mounted hook: executed, when the component is initialized
     */
    mounted: function mounted() {
        // Try to open initial tab based on location hash,
        // Open the first tab, if it fails
        if (!this.openTabBasedOnLocationHash()) {
            this.active = (0, _keys2.default)(this.$slots)[0];
        }

        // Try navigation on every hash change
        // window.addEventListener('hashchange', this.openTabBasedOnLocationHash.bind(this));

        // Initialize priority nav

        //this.randomClass = 'c-ff-tabs-wrapper--' + Math.random().toString(26).substr(2,7);
        this.$el.querySelector('nav').classList.add(this.randomClass);
        _priorityNav2.default.init({
            mainNavWrapper: '.' + this.randomClass, // mainnav wrapper selector (must be direct parent from mainNav)
            mainNav: '.c-ff-tabs', // mainnav selector. (must be inline-block)
            navDropdownLabel: '<svg><use xlink:href="/_assets/ab275dc3b129cc9d1f99b9fb1e696445/Images/icon-sprite.svg#icon-more"/></svg>',
            navDropdownClassName: 'nav__dropdown', // class used for the dropdown.
            navDropdownToggleClassName: 'nav__dropdown-toggle', // class used for the dropdown toggle.
            breakPoint: 480, // amount of pixels when all menu items should be moved to dropdown to simulate a mobile menu
            navDropdownBreakpointLabel: 'Menu' //button label for navDropdownToggle when the breakPoint is reached.
        });
    },


    methods: {

        /**
         * Tries to open a tab based on the current window location hash
         * (or the one that was passed).
         *
         * Returns the name of the new route, if a matching route exists,
         * Does nothing and returns null, if no matching route was found.
         *
         * @returns {string|null}
         */
        openTabBasedOnLocationHash: function openTabBasedOnLocationHash() {
            var hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hash;

            if (this.ignore) {
                return;
            }
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)((0, _keys2.default)(this.tabs)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var identifier = _step2.value;

                    if (hash === '#' + this.url(identifier)) {
                        this.openTab(identifier);
                        return identifier;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return null;
        },


        /**
         * Opens the tab with the given name.
         * @param {string} tab
         */
        openTab: function openTab(tab, event) {
            var _this = this;

            // Prevent default
            if (event && event.preventDefault) {
                event.preventDefault();
            }

            // It is only possible to click a link once in a span of 100ms
            if (this.ignore) {
                return;
            }
            this.ignore = true;
            setTimeout(function () {
                return _this.ignore = false;
            }, 100);

            // Set the currently active tab.
            this.active = tab;
            _globalEventBus.globalEventBus.$emit('tabmenu.navigation', tab);

            // Update the URL.
            // If the browser supports history.replaceState then the hash is written to the URL
            // without pushing to the history. If the browser does not support this method, then it is
            // appended in the traditional way.
            if (window && window.history && window.history.replaceState) {
                window.history.replaceState(undefined, undefined, '#' + this.url(tab));
            } else {
                window.location.hash = this.url(tab);
            }

            // Close dropdown
            var priorityNavWrapper = this.$el.querySelector('.' + this.randomClass);
            if (priorityNavWrapper && priorityNavWrapper.classList.contains('priority-nav-has-dropdown')) {
                priorityNavWrapper.querySelector('.nav__dropdown').classList.remove('show');
                priorityNavWrapper.querySelector('.nav__dropdown-toggle').classList.remove('is-open');
                priorityNavWrapper.classList.remove('is-open');
            }
        },


        /**
         * Returns a URL safe identifier.
         * @param identifier
         * @returns {string}
         */
        url: function url(identifier) {
            return (0, _stringUtility.replaceSpecialCharacters)(identifier.toLowerCase(), {
                'ä': 'ae', 'ö': 'oe', 'ü': 'ue', 'Ö': 'Oe', 'Ü': 'Ue', 'Ä': 'Ae'
            })
            // Strip out HTML Tags
            .replace(/<.*?>/g, '')

            // Convert whitespace & non-word characters to dashes
            .replace(/[\s\W]+/g, '-');
        }
    }

};